<template>
  <div class="fechamentoMes">
      <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <v-icon style="color:white; margin-left:87px">mdi-store</v-icon>
            Loja
            <transition name="slide-fade">
              <v-icon v-if="!empresa._id || !openStore" class="mr-2 ml-2 loading fechamento_loop">loop</v-icon>
            </transition>
          </h2>
        </v-flex>
      </v-layout>
    </div>
    
    <v-card v-if="empresa._id && openStore" class="card_loja" flat>
        <LojaItem v-for="item in items" :key="item.id" :item="item" :conta="conta" :empresa="empresa"/>
    </v-card>

  </div>

</template>

<script>
import LojaItem from '@/pages/loggedArea/loja/lojaItem/LojaItem.vue';
import LojaService from '@/domain/loja/LojaService';

export default {
    props: ["conta", "empresa", "alert"],
    components: { LojaItem },
    mounted() {
      let service = new LojaService();
      const lojaItems = service.getItem();
      this.items = lojaItems;
    },
    data() {
        return {
            items: [],
        }
    },
    watch: {
      empresa(newV, oldV) {
        if(newV !== oldV) {
          this.$store.commit('addOpenStore', true);
        }
      }
    },
    computed: {
      openStore() {
        return this.$store.getters.openStore;
      }
    }
}
</script>

<style scoped>
.fechamentoMes h2 {
  font-weight: normal;
  background-color: teal;
}
.fechamentoMes .fechamento_loop {
  font-size: 22px;
  font-weight: bold;
  color: cyan;
}
.card_loja {
  margin-top: 50px !important;
  width: 95%;
  margin: 0 auto;
  padding: 10px;
  background-color: #efefef;
  display: grid;
  /* display: flex; */
  justify-content: space-between;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.loading {
  animation-name: loading;
  animation: loading 2s infinite;
} 

@media(max-width: 1200px) {
    .card_loja {
        grid-template-columns: 1fr 1fr 1fr
    }
}
@media(max-width: 840px) {
    .card_loja {
        grid-template-columns: 1fr 1fr;
    }
}
@media(max-width: 540px) {
    .card_loja {
        grid-template-columns: 1fr;
    }
}
@-webkit-keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }
  to {
    transform: rotate(180deg) scaleX(-1);
  }
}

@keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }

  to {
    transform: rotate(180deg) scaleX(-1);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/loja/Loja.vue